import { render, staticRenderFns } from "./indexScreen.vue?vue&type=template&id=a0c803dc&scoped=true"
import script from "./indexScreen.vue?vue&type=script&lang=js"
export * from "./indexScreen.vue?vue&type=script&lang=js"
import style0 from "./indexScreen.vue?vue&type=style&index=0&id=a0c803dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c803dc",
  null
  
)

export default component.exports